export enum PLUGIN_NAME {
    RODO_KEYWORD = 'RodoKeyword',
    NETSPRINT = 'NetsprintAudience',
    TESTER = 'Tester',
    AD_CONSOLE = 'AdConsole',
    CUSTOM_KEYWORDS = 'CustomKeywords',
    TCF_KEYWORDS = 'TCFKeywords',
    POCZTA = 'Poczta',
}

export const ENABLED_PLUGINS: PLUGIN_NAME[] = [
    PLUGIN_NAME.RODO_KEYWORD,
    PLUGIN_NAME.NETSPRINT,
    PLUGIN_NAME.TESTER,
    PLUGIN_NAME.AD_CONSOLE,
    PLUGIN_NAME.CUSTOM_KEYWORDS,
    PLUGIN_NAME.TCF_KEYWORDS,
    PLUGIN_NAME.POCZTA,
];

interface IDisabledPlugins {
    host: string;
    plugin: PLUGIN_NAME[];
}
export const DISABLED_PLUGINS: IDisabledPlugins[] = [
    { host: 'www.promoceny.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: 'czateria.interia.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: 'www.encyklopedia.interia.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: 'www.twojapogoda.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: 'naekranie.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: '4fun.tv', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: '4funkids.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
    { host: 'stacja7.pl', plugin: [PLUGIN_NAME.NETSPRINT] },
];
